
import BaseComponent from '../BaseComponent';

class SegmentButton extends BaseComponent{
	
    constructor(aElement){
        
        super(aElement);
        
        this.buttons = this.element.find('.btn-segment');
        this.value   = this.element.find('INPUT[type="hidden"]');
        
        this.attachEvents();
        
    }
    
    attachEvents(){
        
        this.buttons.each( (aIndex, aElement) => {
            
            let button = $(aElement);
            let value = button.data('value');

            button.on('click', (event)=>{
                
                if(!button.hasClass('active')){

                    this.buttons.removeClass('active');
                    button.addClass('active');

                    this.value.val(value);

                    event.stopPropagation();
                    event.preventDefault();
                    
                    this.onChange(this.value.attr('name'),value);
                    
                }
                
            });
            
        });
        
    }
    
}

export default SegmentButton; 